import Tile from "../Tile";
import MUIGreyColor from "@mui/material/colors/grey";
import ModifierCode from "../../Utility/Crud/ModifierCode";
import PropTypes from "prop-types";
import MainContext from "../../Context/MainContext/MainContext";

export default class TileModifierCode extends Tile {
    static contextType = MainContext; // For legacy class components

    /**
      * @returns {string} The ModifierCode name.
      */
    getTitle() {
        return this.props.modifierCode ? ModifierCode.getDisplayName(this.props.modifierCode) : "None";
    }

    /**
     * @returns {string} The string to be used by the avatar abbreviation
     * formatter.
     */
    getAvatarString() {
        return this.props.modifierCode ? ModifierCode.getDisplayName(this.props.modifierCode) : null;
    }

    /**
     * @returns {string} The color of the avatar.
     */
    getAvatarColor() {
        return this.props.modifierCode ? ModifierCode.getColor() : MUIGreyColor[400];
    }

    /**
     * Renders an icon to represent the avatar if no string is provided.
     */
    renderAvatarIcon() {
        return ModifierCode.getIcon();
    }
}
